namespace Matrix.Visualizer {
    export interface GraphThemeForm {
        ThemeKey: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        BackgroundColour: Serenity.StringEditor;
        EdgeColour: Serenity.StringEditor;
        NodeColour: Serenity.StringEditor;
        LeafNodeColour: Serenity.StringEditor;
        RootNodeColour: Serenity.StringEditor;
        NodeTextColour: Serenity.StringEditor;
        NodeBorderColour: Serenity.StringEditor;
        HighlightColour: Serenity.StringEditor;
        DefaultContextMenu: Serenity.StringEditor;
        Version: StaticTextBlock;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
    }

    export class GraphThemeForm extends Serenity.PrefixedContext {
        static formKey = 'Visualizer.GraphTheme';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!GraphThemeForm.init)  {
                GraphThemeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = StaticTextBlock;
                var w2 = ReadOnlyDateTime;

                Q.initFormType(GraphThemeForm, [
                    'ThemeKey', w0,
                    'Description', w0,
                    'BackgroundColour', w0,
                    'EdgeColour', w0,
                    'NodeColour', w0,
                    'LeafNodeColour', w0,
                    'RootNodeColour', w0,
                    'NodeTextColour', w0,
                    'NodeBorderColour', w0,
                    'HighlightColour', w0,
                    'DefaultContextMenu', w0,
                    'Version', w1,
                    'CreatedBy', w1,
                    'CreatedWhen', w2,
                    'UpdatedBy', w1,
                    'UpdatedWhen', w2
                ]);
            }
        }
    }
}
